const STATUS_IDS = {
    notStarted: 1,
    validating: 2,
    ready: 3,
    importing: 4,
    complete: 5,
    failed: 6,
};
export default class ImportProcessStatusDomainService {
    static get NotStartedId() {
        return STATUS_IDS.notStarted;
    }
    static get ValidatingId() {
        return STATUS_IDS.validating;
    }
    static get ReadyId() {
        return STATUS_IDS.ready;
    }
    static get ImportingId() {
        return STATUS_IDS.importing;
    }
    static get CompleteId() {
        return STATUS_IDS.complete;
    }
    static get FailedId() {
        return STATUS_IDS.failed;
    }
    static getStatusIds() {
        return Object.assign({}, STATUS_IDS);
    }
}
